import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import type { Article, Category } from "@/types/content";

export function getAllArticles(): Article[] {
  return articles;
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((item) => item.slug === slug);
}

export function getFeaturedArticle(): Article {
  return articles.find((item) => item.featured) ?? articles[0];
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((item) => item.categorySlug === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getTrendingArticles(limit = 6): Article[] {
  return [...articles].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getRelatedArticles(current: Article, limit = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.categorySlug === current.categorySlug && item.id !== current.id,
  );
  const others = articles.filter(
    (item) => item.categorySlug !== current.categorySlug && item.id !== current.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function getCategoryCount(slug: string): number {
  return articles.filter((item) => item.categorySlug === slug).length;
}